import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import ClinicalEncounter from './ClinicalEncounter';
import { Activity } from 'lucide-react';

const ClinicalEncounterStandalone = () => {
    const { id } = useParams();
    const [appointment, setAppointment] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAppointment();
    }, [id]);

    const fetchAppointment = async () => {
        try {
            const res = await axios.get(`http://localhost:5000/api/appointments/${id}`);
            setAppointment(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (
        <div className="h-screen w-screen bg-[#f8fafc] flex flex-col items-center justify-center gap-6">
            <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin" />
            <p className="text-xl font-black text-indigo-950 uppercase tracking-tighter animate-pulse">Loading Patient Record...</p>
        </div>
    );

    if (!appointment) return <div>Appointment not found.</div>;

    return (
        <div className="min-h-screen bg-[#f1f5f9] p-4 md:p-10 flex flex-col items-center">
            <div className="w-full max-w-6xl">
                <div className="flex items-center gap-4 mb-8">
                    <div className="w-12 h-12 rounded-2xl bg-indigo-600 flex items-center justify-center shadow-2xl shadow-indigo-200">
                        <Activity className="w-6 h-6 text-white" />
                    </div>
                    <div>
                        <h1 className="text-2xl font-black text-slate-800 tracking-tight">Clinical Documentation Console</h1>
                        <p className="text-xs font-bold text-slate-400 uppercase tracking-widest">Encounter ID: #{id} | Unumed Telehealth</p>
                    </div>
                </div>
                <ClinicalEncounter appointment={appointment} onClose={() => window.close()} />
            </div>
        </div>
    );
};

export default ClinicalEncounterStandalone;
